// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TAcceptTermsRequestPayload,
  TAcceptTermsResponsePayload,
  TGetTermsTextsRequestPayload,
  TGetTermsTextsResponsePayload,
  TIsTermsAcceptedRequestPayload,
  TIsTermsAcceptedResponsePayload,
} from './terms.types.ts';

export const createTermsApi = (transport: TApiTransport) => ({
  /** Records the user's acceptance of the current terms of the project */
  acceptTerms: (
    payload: TAcceptTermsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TAcceptTermsRequestPayload, TAcceptTermsResponsePayload>(
      '/accept_terms',
      payload,
      options,
    ),

  /** Returns the terms text of the project, falling back to the global terms */
  getTermsTexts: (
    payload: TGetTermsTextsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TGetTermsTextsRequestPayload, TGetTermsTextsResponsePayload>(
      '/get_terms_texts',
      payload,
      options,
    ),

  /** Checks whether the user accepted the current terms of the project */
  isTermsAccepted: (
    payload: TIsTermsAcceptedRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TIsTermsAcceptedRequestPayload,
      TIsTermsAcceptedResponsePayload
    >('/is_terms_accepted', payload, options),
});
